// extracted by mini-css-extract-plugin
export default {"tabs":"styles-module__tabs___Dz5OY","tab":"styles-module__tab___E1ltE","selected":"styles-module__selected___qq3xt"};